exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.empty-state[data-v-232a49f1] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 24px 16px 28px;\n  line-height: 1.5;\n}\n.empty-accent[data-v-232a49f1] {\n  fill: #f1dfa4;\n}\n.empty-illustration[data-v-232a49f1] {\n  display: block;\n  width: 96px;\n  height: 70px;\n  margin-bottom: 8px;\n}\n.empty-title[data-v-232a49f1] {\n  margin: 0;\n  color: #757575;\n  font-size: 13px;\n  font-weight: 400;\n}\n.empty-description[data-v-232a49f1] {\n  max-width: 320px;\n  margin: 6px 0 0;\n  color: #757575;\n  font-size: 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-232a49f1","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/root/workspace/platform-admin_Cbe5/src/style/theme.scss","/root/workspace/platform-admin_Cbe5/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/element/emptyState.vue
// module id = 894
// module chunks = 30